(() => {
  if (!document.body.classList.contains('mmx-pdp')) return;

  const details =
    document.querySelector('.product-details') ||
    document.querySelector('.product-information__details');

  const move = (el, target, where) => {
    if (!el || !target) return;
    target.insertAdjacentElement(where, el);
    el.hidden = false;
  };

  const box = document.querySelector('[data-mmx-buybox]');
  const reassure = document.querySelector('[data-mmx-reassure]');
  const story = document.querySelector('[data-mmx-story]');

  [box, reassure, story].forEach((el) => {
    if (el) el.hidden = false;
  });

  if (details) {
    const variant = details.querySelector('variant-picker, .variant-picker');
    const buy =
      details.querySelector('product-form-component') ||
      details.querySelector('.buy-buttons') ||
      details.querySelector('form[action*="/cart/add"]');
    const price = details.querySelector('.price, product-price');

    if (box) {
      const after = price || variant;
      if (after) move(box, after, 'afterend');
      else if (buy) move(box, buy, 'beforebegin');
      else {
        details.prepend(box);
        box.hidden = false;
      }
    }

    if (reassure && buy) move(reassure, buy, 'afterend');
    else if (reassure) {
      details.appendChild(reassure);
      reassure.hidden = false;
    }

    const grid =
      document.querySelector('product-information') ||
      document.querySelector('.shopify-section:has(media-gallery)') ||
      details.closest('.shopify-section');
    if (story && grid) move(story, grid, 'afterend');
    else if (story) {
      details.appendChild(story);
      story.hidden = false;
    }

    details.querySelectorAll('h2, .rte h2').forEach((h) => {
      const card = h.closest('.mmx-story, .mmx-facts, .mmx-panel');
      if (card) return;
      const wrap = h.closest('.rte, .shopify-rte') || h.parentElement;
      if (wrap && !wrap.closest('.mmx-story')) wrap.hidden = true;
    });
  } else {
    [box, reassure, story].forEach((el) => {
      if (el) el.hidden = false;
    });
  }

  const desktop = window.matchMedia('(min-width: 750px)');
  const syncFolds = () => {
    document.querySelectorAll('.mmx-story__card--fold').forEach((el) => {
      if (desktop.matches) el.open = true;
    });
  };
  syncFolds();
  desktop.addEventListener('change', syncFolds);

  const labelQuantity = () => {
    const hosts = document.querySelectorAll(
      '.product-details quantity-selector, .product-details .quantity-selector, .product-details quantity-input, product-form-component quantity-selector'
    );
    hosts.forEach((host) => {
      if (host.previousElementSibling && host.previousElementSibling.classList.contains('mmx-qty-label')) return;
      const existing = host.querySelector('label');
      if (existing && /quantit/i.test(existing.textContent || '')) return;
      const lab = document.createElement('p');
      lab.className = 'mmx-qty-label';
      lab.textContent = 'Quantité';
      host.insertAdjacentElement('beforebegin', lab);
    });
  };
  labelQuantity();
  requestAnimationFrame(labelQuantity);

  const priceText =
    (document.body.getAttribute('data-mmx-price') || '').trim() ||
    '';
  document.querySelectorAll(
    'product-form-component button[type="submit"], .product-form button[type="submit"], button[name="add"]'
  ).forEach((btn) => {
    if (!priceText) {
      if (/setup/i.test(btn.textContent || '')) btn.textContent = 'Ajouter au panier';
      return;
    }
    const label = 'Ajouter au panier · ' + priceText;
    btn.textContent = label;
    btn.setAttribute('aria-label', label);
  });
})();
